export default "/assets/images/filter-recommandation-RP.2f90084919e50d6b.webp";